import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MENU } from '../../data/menu.data';
import { Menu } from '../../models/menu.model';
import { AuthService } from '../../services/auth.service';
import { SlideMenuService } from '../../services/slide-menu.service';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss'
})
export class DashboardLayoutComponent implements OnDestroy {

  public outerHeight: number = document.documentElement.clientHeight;

  public menu: Array<Menu>;

  private userSubscription: Subscription;

  constructor(
    public slideMenuService: SlideMenuService,
    private authService: AuthService
  ) {
    this.menu = this.buildMenu(this.authService.currentUser?.profile);

    // El perfil llega de forma asíncrona: el menú se vuelve a armar al recibirlo
    this.userSubscription = this.authService.subCurrentUser.subscribe(
      (user) => this.menu = this.buildMenu(user.profile)
    );
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  /* Solo filtra los ítems que declaran onlyProfiles; el resto se muestra igual
     que siempre (rolesCanAccess no se evalúa aquí). */
  private buildMenu(profile?: string): Array<Menu> {
    return MENU.filter(
      (item) => !item.onlyProfiles
        || (!!profile && item.onlyProfiles.includes(profile))
    );
  }

}
